import { Lang as LightLang } from 'light-infra';

class Lang extends LightLang {

  range(start: number, end: number, step = 1): number[] {
    return Array(end - start).fill(0).map((value, index) => start + (index * step));
  }

  /**
   * 检测文本中是否包含手机号
   * @param text 待检测文本
   * @returns
   */
  isContainPhoneNumber(text: string, phoneRegex = /1[3-9]\d{9}/g): boolean {
    const matches = text.match(phoneRegex);
    return (matches ?? []).length > 0;
  }

  /**
   * 将手机号中间四位数字隐藏
   * @param text
   * @param phoneRegex
   * @returns
   */
  maskPhoneNumber(text: string, phoneRegex = /1[3-9]\d{9}/g): string {
    return text.replace(phoneRegex, match => `${match.slice(0, 3)}****${match.slice(7)}`);
  }

}

export const lang = new Lang();
